import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";
import { SuccessToaster, ErrorToaster } from '../../components/Toaster'

export const inquiryApi = async (data, setName, setEmail, setPhone, setMessage) => {

  try {
    const response = await axios.post(`${baseUrl}booking-inquiry`, data);
    console.log("response from booking-inquiry-api", response)
    SuccessToaster(response.data.message);
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
    return response;
  } catch (error) {
    ErrorToaster(error.response.data.message);
    return null;
  } finally {

  }

};